package com.essntl.features.area.ui.addeditarea

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.country.domain.model.CountryModel

data class AddEditAreaState(
    val area: MutableState<AreaModel> = mutableStateOf(AreaModel.empty),
    val getArea: State<AreaModel> = State(),
    val addEditArea: State<AreaModel> = State(),
    val deleteArea: State<Unit> = State(),
    val isEditEnabled: Boolean = false,

    // Area Count
    val getProposalsAreaCount: State<Long> = State(),
    val getSuppliersAreaCount: State<Long> = State(),

    // Countries
    val getAllCountries: State<List<CountryModel>> = State(),
    val addCountry: State<CountryModel> = State(),
) {
    val countLoading
        get() = getProposalsAreaCount.isLoading ||
            getSuppliersAreaCount.isLoading

    val count
        get() = (getProposalsAreaCount.data ?: 0) +
            (getSuppliersAreaCount.data ?: 0)
}
